<template>
    <div class="recruit_container">
        <div class="recruit_section03">
            <div class="recruit_head">02. 복리후생</div>
            <v-container fluid class="cards">
                <v-row>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_01.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">금요일은 5시 퇴근</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        열심히 일한 당신의 주말을 더 길~게! <br>
                                        매 주 금요일은 한 시간 일찍 퇴근합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_02.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">점심식사 제공</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        맛있는 점심! 내 돈 주고 사먹지 말자 <br>
                                        DU가 점심식사를 제공합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_03.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">성과급 지급</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        열심히 일한 당신! <br>
                                        당신의 노고에 보상해 드립니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_04.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">생일선물 지급</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        소중한 당신의 생일을 축하합니다! <br>
                                        생일이 되면 생일 선물을 지급합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_05.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">4대 보험 가입</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        업무 중 무슨 일이 생겼나요?<br>
                                        4대 보험으로 안전하게 일하세요.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_06.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">명절선물 지급</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        행복한 명절을 위한 선물!<br>
                                        양손 무겁게 집에 보내드립니다!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_07.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">통신비 지원</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        다양한 서비스, 마음껏 사용해보세요. <br>
                                        통신비 지원으로 부담을 덜어드립니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_08.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">경조금 지원</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        기쁨과 슬픔, 함께 나눠요.<br>
                                        DU에서는 각종 경조금을 지원합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_09.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">건강검진 매년 시행</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        당신의 몸은 소중하니까<br>
                                        건강검진을 지원해 드립니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_010.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">단체예방접종</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        나의 건강, 우리 모두의 건강을 위해!<br>
                                        필요 시 단체로 예방접종을 지원합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_11.png" class="edu_icon">
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">교육비 지원</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        성장을 위해 교육이 필요한가요?<br>
                                        DU가 당신의 성장을 지원합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :cols="cols">
                        <div class="content_card">
                            <div class="card_img">
                                <img src="../../assets/img/recruit/icon_recruit_welfare_12.png" >
                            </div>
                            <div class="card_text">
                                <div class="card_title">
                                    <span class="recruit_head">도서구입 지원</span>
                                </div>
                                <div class="card_detail">
                                    <div class="recruit_welfare_body">
                                        업무 능력 향상을 위해 책이 필요하다면?<br>
                                        DU가 구입 비용을 지원합니다.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>
<script>
export default {
	name: 'section03',
	data: () => ({}),
	computed: {
		cols () {
			switch (this.$vuetify.breakpoint.name) {
			default: return 6
			case 'xs': return 12
			}
		}
	}
}
</script>
